import React from 'react';
import SEO from '../../components/SEO';
import BannerMask from '../../components/BannerMask';
import { Container } from 'reactstrap';
import InnerBanner from '../../components/InnerBanner';
import ExpertiseDetail from './components/ExpertiseDetail';
import ExpertiseListing from './components/ExpertiseListing';
import {
  corporateLawData,
  corporateLawListingData,
  customListingData,
  customsLawData,
  expertiseDetailData,
  expertiseListingData,
  goodsAndServiceListingData,
  goodsAndServicesData,
} from '../../constants/expertiseData';
import { expertiseCardsData } from '../../constants/expertiseCardsData';
import ClickableCardsSection from './components/ClickableCardsSection';
import expertiseImage from '../../assets/images/cyberLawTech.png';
import customLawImage from '../../assets/images/Custom-law.png';
import goodsAndServiceImage from '../../assets/images/GoodsAndServices.png';
import ContactImage from '../../assets/images/expertise-contact-banner.png';
import corporateLaw from '../../assets/images/corporateLaw.png';
import ContactSection from './components/ContactSection';
import SectionHeader from '../../components/SectionHeader';
const Expertise = () => {
  return (
    <>
      <SEO title="Expertise" />
      <div className="resource">
        <InnerBanner
          title="Expertise"
          description="At Legalligence, we deliver focused legal expertise supercharged by technology. Our services are designed to help corporates, law firms, and legal professionals navigate complex regulatory landscapes with solutions that are faster, smarter, and more efficient."
        />
        <section className="section-gap-lg">
          <Container>
            <SectionHeader title="Cyber Law" />
            <div className="expertise-cyber-law">
              <ExpertiseDetail paragraphs={expertiseDetailData.paragraphs} image={expertiseImage} />
              <ExpertiseListing items={expertiseListingData} />
              <h3 className="sector-focused-head" data-aos="fade-up">
                Sectors Focused
              </h3>
              <ClickableCardsSection cards={expertiseCardsData} />
            </div>
          </Container>
        </section>
        <section className="expertise-custom-law section-gap-lg">
          <Container>
            <SectionHeader title="Customs Law" />
            <div className="custom-law">
              <ExpertiseDetail
                paragraphs={customsLawData.paragraphs}
                image={customLawImage}
                imageOnLeft={true}
              />
              <ExpertiseListing items={customListingData} />
            </div>
          </Container>
        </section>
        <div className="contact-section-banner">
          <ContactSection
            title="Let’s Talk"
            description="Have legal questions or need guidance? Our experts are here to provide clear advice and reliable support."
            bgImage={ContactImage}
            buttonLabel="Contact Us"
            buttonLink="/contact-us"
          />
        </div>

        <section className="section-gap-lg">
          <Container>
            <SectionHeader title="Goods And Services Tax (Gst)" />
            <div className="expertise-cyber-law">
              <ExpertiseDetail
                paragraphs={goodsAndServicesData.paragraphs}
                image={goodsAndServiceImage}
              />
              <ExpertiseListing items={goodsAndServiceListingData} />
            </div>
          </Container>
        </section>
        <section className="expertise-custom-law section-gap-lg corporate-section">
          <Container>
            <SectionHeader title="Corporate Law" />
            <div className="custom-law">
              <ExpertiseDetail
                paragraphs={corporateLawData.paragraphs}
                image={corporateLaw}
                imageOnLeft={true}
              />
              <ExpertiseListing items={corporateLawListingData} />
            </div>
          </Container>
        </section>
      </div>
    </>
  );
};

export default Expertise;
